<!--
svg-icon
描述：
将svg后缀的图片转化为inline svg格式

用例：
<svg-icon width="12" height="12" src="icon.svg" fill="#43Cb83"></svg-icon>
//-->
<template>
  <i class="svg-icon-component" :class="{ 'svg-icon-align-middle': alignMiddle }" :width="width" :height="height" @click="_triggerClickEvent()"
    ><img :src="src" :width="width" :height="height"
  /></i>
</template>

<script>
export default {
  props: {
    width: {
      type: [Number, String],
      default: 20
    },
    height: {
      type: [Number, String],
      default: 20
    },
    // 填充的颜色
    fill: String,
    // 图片源
    src: String,
    // 是否垂直对齐
    alignMiddle: {
      type: Boolean,
      default: true
    },
    // 向上偏移，单位是px
    topOffset: {
      type: [Number, String],
      default: 0
    }
  },
  data: function() {
    return {}
  },
  watch: {
    fill: function() {
      $(this.$el)
        .find('svg path')
        .css('fill', this.fill)
    }
  },
  mounted: function() {
    this.svg2inline(this.setStyle)
  },
  methods: {
    _triggerClickEvent() {
      this.$emit('click')
    },
    setStyle(svgElem) {
      svgElem.width(this.width)
      svgElem.height(this.height)
      svgElem.css('margin-top', this.topOffset)

      var self = this
      if (this.fill !== null) {
        let pathElems = svgElem.find('path')
        $.each(pathElems, function(index, pathElem) {
          $(pathElem).css('fill', self.fill)
        })
      }
    },
    svg2inline(callback) {
      var $img = $(this.$el).find('img')
      var imgID = $img.attr('id')
      var imgClass = $img.attr('class')
      var imgURL = this.src

      $.get(
        imgURL,
        function(data) {
          // Get the SVG tag, ignore the rest
          var $svg = $(data).find('svg')

          // Add replaced image's ID to the new SVG
          if (typeof imgID !== 'undefined') {
            $svg = $svg.attr('id', imgID)
          }
          // Add replaced image's classes to the new SVG
          if (typeof imgClass !== 'undefined') {
            $svg = $svg.attr('class', imgClass + ' replaced-svg')
          }
          // $svg.attr('width', self.width);
          // $svg.attr('height', self.height);

          // Remove any invalid XML tags as per http://validator.w3.org
          $svg = $svg.removeAttr('xmlns:a')

          // Replace image with new SVG
          $img.replaceWith($svg)

          callback($svg)
        },
        'xml'
      )
    }
  }
}
</script>

<style lang="scss" scoped>
.svg-icon-component {
  display: inline-block;
  line-height: 0px;
}
.svg-icon-align-middle {
  vertical-align: middle;
}
</style>
